<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="employee_access"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="accessForm"
          :redirect-detail="false"
          :show-add-button="true"
          caption="<i class='fa fa-align-justify'></i> Menu Karyawan"
          addButton="Tambah Akses"
          @editForm="editForm"
          @resetForm="resetForm"
        ></global-table>

        <b-modal
          ref="myModalRef"
          id="addModals"
          header-border-variant="no-border text-center"
          footer-border-variant="no-border"
          footer-bg-variant="light"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          size="lg"
        >
          <div slot="modal-header" class="text-center">
            <h3 class="text-center" v-if="!isEdit">Tambah Divisi Baru</h3>
            <h3 class="text-center" v-else-if="isEdit">Ubah Divisi</h3>
          </div>

          <b-form id="accessForm" validated novalidate>
            <div v-if="!loadingSubmitModal">
              <b-row>
                <b-col sm="4" v-if="!isEdit">
                  <b-form-group label-for="nik" label="Employee">
                    <model-select
                      id="nik"
                      :options="listEmployee"
                      v-model="$v.accessForm.nik.$model"
                      :isError="$v.accessForm.nik.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="accessForm.nik === null"
                      class="invalid-feedback-custom"
                    >Employee harus di pilih.</div>
                  </b-form-group>
                </b-col>

                <b-col sm="4">
                  <b-form-group label-for="start_page" label="Start Page">
                    <model-select
                      id="nik"
                      :options="listStartPage"
                      v-model="$v.accessForm.start_page.$model"
                      :isError="$v.accessForm.start_page.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="accessForm.start_page === null"
                      class="invalid-feedback-custom"
                    >Employee harus di pilih.</div>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="12">
                  <b-form-group label-for="menu" label="Access Menu Karyawan">
                    <multi-select
                      :options="listMenu"
                      :selected-options="myMenu"
                      placeholder="-- Harap pilih salah satu --"
                      v-model="$v.accessForm.menu.$model"
                      :isError="$v.accessForm.menu.$invalid"
                      @select="onSelectMenu"
                    ></multi-select>
                    <div
                      v-if="accessForm.menu === null || accessForm.menu.length === 0"
                      class="invalid-feedback-custom"
                    >Group konsumen Non GT harus di isi.</div>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
            <div v-else>
              <loading></loading>
            </div>
          </b-form>

          <div slot="modal-footer" class="float-right">
            <div v-if="!loadingSubmitModal">
              <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
                <i class="fa fa-undo"></i> Back
              </b-button>&nbsp;
              <b-button
                type="button"
                size="sm"
                variant="primary"
                @click="saveProcess"
                :disabled="$v.accessForm.$invalid"
              >
                <i class="fa fa-save"></i> Save
              </b-button>
            </div>
          </div>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import masterInterfaces from "@/templates/_master_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect, MultiSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";

export default {
  name: "employee_access",
  components: { globalTable, ModelSelect, MultiSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      employee_access: [],
      listEmployee: [],
      listMenu: [],
      listStartPage: [],
      myMenu: [],
      loading: true,
      loadingSubmitModal: false,
      fields: [
        {
          key: "name",
          label: "Nama Karyawan",
          class: "width-250",
          sortable: true
        },
        { key: "myMenuName", label: "Menu" },
        { key: "action", class: "width-50 text-center" }
      ],
      accessForm: masterInterfaces.access_menu,
      isEdit: false
    };
  },
  validations: {
    accessForm: {
      nik: { required },
      menu: { required },
      start_page: { required }
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    init: function() {
      this.getDropdown();
      this.getAllUserAccess();
    },
    getDropdown: function() {
      this.axios
        .get("web/dropdown/dropdown-access-menu/")
        .then(response => {
          this.listEmployee = response.data.employee;
          this.listMenu = response.data.menu;
          this.listStartPage = response.data.start_page;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getAllUserAccess: function() {
      this.axios
        .get("web/master/employee/access_menu/all/")
        .then(response => {
          this.employee_access = response.data.data;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    onSelectMenu(items, lastSelectItem) {
      this.myMenu = items;
      this.accessForm.menu = items;
    },
    editForm: function(e) {
      this.isEdit = true;
      this.resetForm();
      this.accessForm = e;
      this.accessForm.menu = e.myMenu;
      this.myMenu = e.myMenu;
    },
    resetForm: function() {
      for (var a in masterInterfaces.access_menu) {
        masterInterfaces.access_menu[a] = null;
      }
      this.accessForm = masterInterfaces.access_menu;
    },
    cancelAdd: function() {
      this.isEdit = false;
      this.$refs.myModalRef.hide();
      this.init();
    },
    saveProcess: function(evt) {
      evt.preventDefault();
      if (this.isEdit) {
        if (confirm("Apakah anda ingin mengubah divisi ini?")) {
          this.loadingSubmitModal = true;
          this.axios
            .put("web/master/employee/access_menu/edit/", this.accessForm)
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Access Berhasil",
                  message: response.data.message
                });
              }
            })
            .catch(error => {
              this.expired(error);
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAdd();
              this.init();
            });
        }
      } else {
        if (confirm("Apakah anda ingin menambahkan divisi ini?")) {
          this.loadingSubmitModal = true;
          this.axios
            .post("web/master/employee/access_menu/add/", this.accessForm)
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Tambah Access Berhasil",
                  message: response.data.message
                });
              } else {
                this.showErrorNotification({
                  title: "Tambah Access Gagal",
                  message: response.data.message
                });
              }
            })
            .catch(error => {
              this.expired(error);
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAdd();
              this.init();
            });
        }
      }
    },
    expired: function(error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: "Master Divisi Karyawan",
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

  